import jsSVG from "jsSVG";

export default function imageToSvgService($q, $window, $document) {
    "ngInject";

    const IMAGE_PADDING_RATIO = 0.2;

    return {
        createSvgSourceFromImageFile,
        createSvgSourceFromImageData,
    };

    function createSvgSourceFromImageFile(file) {
        return readFileAsDataUrl(file).then(function (imageSource) {
            return loadImageDimensions(imageSource).then(function (dimensions) {
                return createSvgSourceFromImageData(
                    imageSource,
                    dimensions.width,
                    dimensions.height
                );
            });
        });
    }

    function createSvgSourceFromImageData(imageSource, width, height) {
        if (typeof imageSource !== "string" || !imageSource) {
            return $q.reject(new Error("Invalid image source."));
        }

        if (!Number.isFinite(width) || !Number.isFinite(height)) {
            return $q.reject(new Error("Invalid image dimensions."));
        }

        if (width <= 0 || height <= 0) {
            return $q.reject(new Error("Invalid image dimensions."));
        }

        const horizontalPadding = width * IMAGE_PADDING_RATIO;
        const verticalPadding = height * IMAGE_PADDING_RATIO;
        const svgWidth = width + horizontalPadding * 2;
        const svgHeight = height + verticalPadding * 2;

        const container = $document[0].createElement("div");
        const drawing = jsSVG(container);
        drawing.viewbox({
            x: 0,
            y: 0,
            width: svgWidth,
            height: svgHeight,
        });
        drawing.attr({
            xmlns: "http://www.w3.org/2000/svg",
            width: svgWidth,
            height: svgHeight,
        });

        drawing
            .image(imageSource)
            .move(horizontalPadding, verticalPadding)
            .size(width, height)
            .attr({
                preserveAspectRatio: "none",
            });

        return $q.resolve(drawing.svg());
    }

    function readFileAsDataUrl(file) {
        return $q(function (resolve, reject) {
            const fileReader = new FileReader();

            fileReader.onerror = function () {
                reject(new Error("Failed to read image."));
            };

            fileReader.onload = function () {
                if (typeof fileReader.result !== "string") {
                    reject(new Error("Invalid image source."));
                    return;
                }

                resolve(fileReader.result);
            };

            fileReader.readAsDataURL(file);
        });
    }

    function loadImageDimensions(imageSource) {
        return $q(function (resolve, reject) {
            const image = new $window.Image();

            image.onload = function () {
                const width = image.naturalWidth || image.width;
                const height = image.naturalHeight || image.height;

                if (width <= 0 || height <= 0) {
                    reject(new Error("Invalid image dimensions."));
                    return;
                }

                resolve({ width, height });
            };

            image.onerror = function () {
                reject(new Error("Failed to load image."));
            };

            image.src = imageSource;
        });
    }
}
